// PoweredByFooter — read-only footer shown in all email compose dialogs
// Tenants cannot modify or remove this element
import React from 'react';

const PoweredByFooter = () => (
  <div className="mt-1 pt-3 border-t border-dashed border-gray-200">
    <div className="flex items-center justify-between mb-1">
      <span className="text-[10px] text-muted-foreground uppercase tracking-wide select-none">
        Email footer (non-editable)
      </span>
    </div>
    <div className="rounded bg-gray-50 border border-gray-200 p-3 text-center pointer-events-none select-none">
      <img
        src={`${window.location.origin}/api/brand/powered-by-footer.png`}
        alt="Powered By Green Door"
        style={{ maxHeight: 32, display: 'inline-block' }}
        draggable={false}
      />
    </div>
  </div>
);

export default PoweredByFooter;
